import { render, staticRenderFns } from "./ChangeAvatar.vue?vue&type=template&id=212b77e6&scoped=true&"
import script from "./ChangeAvatar.vue?vue&type=script&lang=js&"
export * from "./ChangeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAvatar.vue?vue&type=style&index=0&id=212b77e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b77e6",
  null
  
)

export default component.exports